
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Choice_Completed_Winner = class Notification_Choice_Completed_Winner {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _denied_modal_init = false;
    static _denied_modal_action = null;

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let meta;
        let bid_id = null;
        let item_ids = null;
        let auction_id = null;

        meta = JSON.parse(this.notification.meta)
        bid_id = meta.bid_id;
        item_ids = meta.item_ids;
        auction_id = meta.auction_id;

        if (!_.Notification_Choice_Completed_Winner.denied_modal_init) {
            _.Notification_Choice_Completed_Winner.denied_modal_init = true;
            $("#ac-modal-choice-completed-winner-close").click(function (e) {
                e.preventDefault();
                _.Modal.close_unhidable();
            });
        }

        // The modal itself.
        // Call resolve when we are done here.
        await new Promise(function (resolve, reject) {
            (async function () {

                console.log("We should be looking at it");

                $(".ac-modal-choice-completed-winner-round-number").text(meta.round_number);

                let subtotal = 0;

                let auction = await App_Models_Auction.fetch_private(auction_id);

                // Build all DOM content in a detached fragment first, then replace atomically.
                // Prevents duplicate rendering when on_show() is called concurrently.
                let $fragment = $("<div></div>");

                try {
                    let seen_ids = {};
                    for (let item_id of meta.item_ids) {
                        if (seen_ids[item_id]) continue;
                        seen_ids[item_id] = true;

                        let item = await App_Models_AuctionItem.fetch_private(item_id);
                        let round = await item.auction_round.fetch();

                        let high_bid = round.current_bid_amount;

                        let $item = $("<div style='max-width:85%;'></div>");
                        $item.attr('style', 'margin-bottom: 15px; margin-top: 5px;');
                        let $item_header = $("<div></div>").text(item.title).style('font-weight', 'bold');
                        $item.append($item_header);

                        // Choice round, always per acre.
                        let $item_calc = $("<div></div>").attr('style', 'padding-bottom: 1px; border-bottom: 1px solid #000; margin-bottom: 3px;');
                        let $high_bid = $("<span></span>").text(_.currency(high_bid)).style('font-weight', 'bold');
                        let $acres_text = $("<span></span>").text(
                            " x " + item.acres + " " + _.property_noun_unit_abbr_plusminus() + " ="
                        );
                        $item_calc.append($high_bid);
                        $item_calc.append($acres_text);
                        $item.append($item_calc);

                        let $total_calc = $("<div></div>").text(_.currency(item.sale_price)).style('font-weight', 'bold');
                        $item.append($total_calc);

                        $fragment.append($item);

                        subtotal += item.sale_price;
                    }

                    let $total_container = $("<div></div>").attr('style', 'display: table; margin: auto;');

                    let $total_label = $("<div></div>").text("TOTAL").attr('style', 'font-size: 24px;font-weight: bold;');
                    $total_container.append($total_label);

                    let $subtotal_line = $("<div></div>").text(_.currency(subtotal) + " subtotal").style('font-style', 'italic');
                    $total_container.append($subtotal_line);

                    let $total_fees_representation = $("<div></div>").attr('style', 'padding-bottom: 1px; border-bottom: 1px solid #000; margin-bottom: 3px;');
                    $total_fees_representation.text("+ " + _.percentage(auction.total_fees) + " fees =").style('font-style', 'italic');
                    $total_container.append($total_fees_representation);

                    let $final_total_line = $("<div></div>")
                        .text(_.currency(subtotal * (1 + (auction.total_fees / 100))))
                        .attr('style', 'font-weight: bold; font-size: 20px; margin-bottom: 23px;');
                    $total_container.append($final_total_line);

                    $fragment.append($total_container);

                    // Atomic DOM replacement -- prevents interleaved content from concurrent calls
                    $("#ac-modal-choice-completed-winner-items-list").empty().append($fragment.children());

                } catch (e) {
                    console.error(e);
                    $items_sold.append("<li>(Error loading items list)</li>");
                }

                if (meta.paddle_number) {
                    $("#ac-modal-choice-completed-winner-message-no-paddle").hide();
                    $("#ac-modal-choice-completed-winner-message-with-paddle").show();
                    $(".ac-modal-choice-completed-winner-paddle-number").text(meta.paddle_number);
                } else {
                    $("#ac-modal-choice-completed-winner-message-no-paddle").show();
                    $("#ac-modal-choice-completed-winner-message-with-paddle").hide();
                }

                if (meta.items_remain) {
                    $("#ac-modal-choice-completed-winner-no-items-remain").hide();
                    $("#ac-modal-choice-completed-winner-next-round-pending").show();
                    $('#ac-modal-choice-completed-winner-count-items-remain').text(meta.items_remain);
                } else {
                    $("#ac-modal-choice-completed-winner-no-items-remain").show();
                    $("#ac-modal-choice-completed-winner-next-round-pending").hide();
                }

                let deferred = $.Deferred();

                $("#ac-modal-choice-completed-winner-modal").data('deferred', deferred);

                $("#ac-modal-choice-completed-winner-modal").modal_show();
                _.Modal.set_unhidable();

                // Override the default modal-close behavior to call close_unhidable()
                // The global .modal-close handler calls _.Modal.hide() which is blocked by set_unhidable()
                $("#ac-modal-choice-completed-winner-modal .modal-close").off('click').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _.Modal.close_unhidable();
                });

                // Wait for the modal to close.
                await deferred.promise();

                _.Modal.close_unhidable();

                resolve();
            })();
        });

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
    }
}